import type * as React from 'react';
import { cn } from './lib/cn';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  // React 19 aceita `ref` como prop normal em componentes de funcao.
  ref?: React.Ref<HTMLInputElement>;
  /** Simbolo fixo dentro do campo, a esquerda (ex.: "R$", "%"). */
  prefix?: React.ReactNode;
}

export function Input({ className, type, ref, prefix, onClick, ...props }: InputProps) {
  const data = type === 'date' || type === 'time' || type === 'datetime-local';

  const field = (
    <input
      type={type}
      ref={ref}
      // Num campo de data, so o iconezinho abria o calendario - clicar no
      // meio do campo, que e o que todo mundo faz, punha o cursor no dia e
      // parecia quebrado. Aqui o campo inteiro e a area de clique.
      onClick={(event) => {
        if (data) event.currentTarget.showPicker?.();
        onClick?.(event);
      }}
      className={cn(
        // Estilo unico dos campos do sistema: preenchimento discreto em
        // repouso e o campo "acende" no foco - fundo limpo, borda e anel
        // na cor primaria. E o que mantem a tela plana sem ficar apagada.
        'flex w-full rounded-md border border-input bg-muted/50 transition-colors placeholder:text-muted-foreground hover:bg-muted focus-visible:border-primary focus-visible:bg-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50',
        // 16px no celular e obrigatorio: com fonte menor o iOS aplica zoom
        // sozinho ao focar o campo e desalinha a tela toda.
        'h-11 px-3 py-1 text-base sm:h-9 sm:text-sm',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        // O icone do calendario e preto fixo do navegador: no tema escuro
        // sumia contra o fundo.
        data &&
          'cursor-pointer [&::-webkit-calendar-picker-indicator]:cursor-pointer dark:[&::-webkit-calendar-picker-indicator]:invert',
        prefix && 'pl-10',
        className,
      )}
      {...props}
    />
  );

  if (!prefix) return field;

  return (
    <span className="relative block">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
        {prefix}
      </span>
      {field}
    </span>
  );
}
